export default {
  title:
    "Lieferung an deinen Standort: Benötigter Betrag, um den Mindestbestellwert zu erreichen. (Zwischensumme abz. Lieferkosten & Trinkgeld)",
  description:
    "Leider kannst du noch nicht bestellen. {{name}} liefert erst ab einem Mindestbestellwert von {{threshold}} (abz. Lieferkosten & Trinkgeld)",
};
